/**
 * Le brouillon du tunnel, le temps d'un aller-retour.
 *
 * « Continuer avec Google » quitte le site (`/auth/google/redirect`) et revient
 * sur la fiche : sans rien garder, le client retrouverait un tunnel vide après
 * avoir tout rempli. On garde donc l'adresse, le problème et les horaires dans
 * `sessionStorage`, par fiche, et on les rend une seule fois au retour.
 *
 * `sessionStorage` et non Redux : le magasin persisté (`dumpStore`) survit aux
 * sessions et ferait réapparaître une demande abandonnée des jours plus tard.
 * Toutes les lectures et écritures sont gardées : navigation privée, stockage
 * bloqué ou rendu serveur ne doivent jamais casser la fiche.
 */
const cle = (shopId) => `rj-annuaire-tunnel-${shopId}`;
const DUREE_MAX_MS = 60 * 60 * 1000;

export function garderBrouillon(shopId, brouillon) {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(
      cle(shopId),
      JSON.stringify({ ...brouillon, garde: Date.now() }),
    );
  } catch (e) {
    // Stockage refusé : le client ressaisira, rien de plus grave.
  }
}

/**
 * Rend le brouillon s'il existe et a moins d'une heure, puis l'efface.
 * Un brouillon gardé par un compte n'est rendu qu'à ce compte : sur un
 * navigateur partagé, l'adresse d'un client ne s'affiche pas chez un autre.
 */
export function reprendreBrouillon(shopId, clientId = null) {
  if (typeof window === 'undefined') return null;
  try {
    const brut = window.sessionStorage.getItem(cle(shopId));
    window.sessionStorage.removeItem(cle(shopId));
    if (!brut) return null;
    const brouillon = JSON.parse(brut);
    if (!brouillon || Date.now() - brouillon.garde > DUREE_MAX_MS) return null;
    if (brouillon.clientId && brouillon.clientId !== clientId) return null;
    return brouillon;
  } catch (e) {
    return null;
  }
}

export function oublierBrouillon(shopId) {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(cle(shopId));
  } catch (e) {
    // rien
  }
}
